export const getBasename: () => string = () => {
  const basename = window.location.pathname.replace(/^\/([^/]+).*/, '/$1');
  return basename === '/Fundraiser' || basename === '/Account' ? '/' : basename;
};
